export default __webpack_public_path__ + "static/web20240227-4f7fe757947bbf6076fcf94941ae59fe.png";